// ASTT-7178: compact legend explaining the roster picker's color coding
// -- shared between Hand Off and Training Notes (see rosterStatusColors.js
// for why one shared map/legend covers both). Rendered inline, on the
// same row as the "Class Roster Ids" label, per direct request -- no
// vertical space of its own.
import { Box } from "@mui/material";
import {
  ROSTER_STATUS_COLORS,
  ROSTER_STATUS_BORDER_COLORS,
  ROSTER_STATUS_LEGEND_ITEMS,
} from "./rosterStatusColors";

export default function RosterStatusLegend() {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      {ROSTER_STATUS_LEGEND_ITEMS.map((item) => (
        <Box
          key={item.status}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "2px",
              backgroundColor: ROSTER_STATUS_COLORS[item.status] || "#fff",
              border: `1px solid ${ROSTER_STATUS_BORDER_COLORS[item.status]}`,
              flexShrink: 0,
            }}
          />
          <Box component="span" sx={{ fontSize: "0.7rem", color: "#607d8b" }}>
            {item.label}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
